import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import normalize from "json-api-normalizer";
import { mergeMap } from "rxjs/operators";
import { FORM_ERROR } from "final-form";
import { empty } from "rxjs";
import AttachmentService from "../services/attachmentService";
import activeStorageUpload from "../services/uploadService";

import {
  loadAttachmentsSuccess,
  loadAttachmentsFailure,
  LOAD_ATTACHMENTS_REQUEST_ACTION,
  uploadAttachmentsSuccess,
  uploadAttachmentsFailure,
  UPLOAD_ATTACHMENTS_REQUEST_ACTION,
  UPLOAD_ATTACHMENTS_SUCCESS_ACTION,
  attachAttachmentsSuccess,
  attachAttachmentsFailure,
  uploadAttachmentsRequest,
  ATTACH_ATTACHMENTS_SUCCESS_ACTION,
  attachAttachmentsRequest,
  ATTACH_ATTACHMENTS_REQUEST_ACTION,
  DOWNLOAD_FILE_REQUEST_ACTION,
  downloadFileSuccess,
  downloadFileFailure
} from "../ducks/data";
import { setActiveDialog } from "../ducks/app";
import { SAVE_ATTACHMENT_FORM_REQUEST_ACTION } from "../ducks/attachments";
import {
  IMPORT_FORM_REQUEST_ACTION,
  importFormSuccess,
  importFormFailure,
  IMPORT_FORM_SUCCESS_ACTION
} from "../ducks/import";
import { parseError } from "./lib";
import EmptyState from "../pages/Patient/EmptyState";

const _ = require("lodash");
const FileDownload = require("js-file-download");

export const importFormEpic = (action$, state$) =>
  action$.pipe(
    ofType(IMPORT_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let attachmentService = new AttachmentService();

      return concat(
        attachmentService
          .importData(action.payload.file, action.payload.type)
          .then(response => {
            // TODO: create attachments with blob signed ids and return them
            return importFormSuccess(normalize(response.data));
          })
          .catch(error => {
            // Send message back to form
            let e = parseError(error);
            let errors = {
              [FORM_ERROR]: e.detail
            };
            return importFormFailure(errors);
          })
      );
    })
  );

export const importFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(IMPORT_FORM_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      return of(setActiveDialog());
    })
  );

export const loadAttachmentsEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_ATTACHMENTS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let attachmentService = new AttachmentService();
      return attachmentService
        .findAll()
        .then(response => {
          return loadAttachmentsSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadAttachmentsFailure(error);
        });
    })
  );

export const saveLibraryFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_ATTACHMENT_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(uploadAttachmentsRequest(action.payload));
    })
  );

export const uploadAttachmentsEpic = (action$, state$) =>
  action$.pipe(
    ofType(UPLOAD_ATTACHMENTS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let uploads = action.payload.attachments.map(file =>
        activeStorageUpload(file)
      );

      return concat(
        Promise.all(uploads)
          .then(blobs => {
            let attachments = action.payload;
            attachments.attachments = blobs;
            // TODO: create attachments with blob signed ids and return them
            return attachAttachmentsRequest(attachments);
          })
          .catch(error => {
            return uploadAttachmentsFailure(error);
          }),
        of(uploadAttachmentsSuccess())
      );
    })
  );

export const attachAttachmentsEpic = (action$, state$) =>
  action$.pipe(
    ofType(ATTACH_ATTACHMENTS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let attachmentService = new AttachmentService();
      let secureKeys = _.first(action.payload.attachments).signed_id;
      let attachment = {
        ...action.payload
      };
      attachment.attributes.secureKeys = secureKeys;
      return attachmentService
        .save(attachment, action.payload.type)
        .then(response => {
          // TODO: create attachments with blob signed ids and return them
          return attachAttachmentsSuccess(normalize(response.data));
        })
        .catch(error => {
          return attachAttachmentsFailure(error);
        });
    })
  );

export const saveLibraryFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(ATTACH_ATTACHMENTS_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      let activeDialog = state$.value.app.activeDialog;
      return activeDialog === "library-update"
        ? of(setActiveDialog())
        : empty();
    })
  );

export const getFileEpic = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_FILE_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let attachmentService = new AttachmentService();
      return attachmentService
        .download(action.payload.url)
        .then(response => {
          FileDownload(response.data, action.payload.fileName);
          return downloadFileSuccess();
        })
        .catch(error => {
          return downloadFileFailure(error);
        });
    })
  );



// WEBPACK FOOTER //
// ./src/epics/attachments.js